import { Button, Select, Td, Tr, useToast } from '@chakra-ui/react'
import { DesativarPeriodo } from './DesativarPeriodo'
import { api } from '../../../services/api'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { InfoVendedor } from './InfoVendedor'
import { DesligarVendedor } from './DesligarVendedor'
import { AtivarRotinas } from './AtivarRotinas'
import { RetornarPadrao } from './RetornarPadrao'

async function changeFila(params) {
  const paramsT = {
    codigo_usuario: params.codigo_usuario,
    codigo_vendedor: params.codigo_vendedor,
    nome_vendedor: params.nome_vendedor,
    ativacao: params.ativacao,
  }

  const response = await api.post('/site/v2/controle-rodizio/ativacao-vendedor', paramsT)

  return response.data
}

export function Item({ vendedor }) {
  const toast = useToast({
    position: 'top-right',
    isClosable: true,
  })

  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: changeFila,
    onError: (error, variables, context) => {
      toast({
        title: 'Erro ao alterar vendedor',
        status: 'error',
      })
    },
    onSuccess: (data, variables, context) => {
      console.log(data)
      toast({
        title: 'Vendedor alterado com sucesso',
        status: 'success',
      })

      queryClient.invalidateQueries('controle-rodizio')
    },
  })

  async function handleChangeFila(vendedor, active) {
    const params = {
      codigo_usuario: vendedor.codigo_usuario,
      codigo_vendedor: vendedor.codigo_vendedor,
      ativacao: active,
      nome_vendedor: vendedor.nome_vendedor,
    }
    try {
      await mutateAsync(params)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Tr key={vendedor.codigo_vendedor} bg={vendedor.ativo === 'N' ? 'red.100' : vendedor.agendamento === 'S' ? 'yellow.100' : 'green.100'}>
      <Td textTransform="capitalize">{vendedor.nome_vendedor}</Td>
      <Td>{vendedor.ultimo_chamado}</Td>
      <Td>
        <Select placeholder="Selecione" size="sm" value={vendedor.ativo} onChange={(e) => handleChangeFila(vendedor, e.target.value)}>
          <option value="S">Sim</option>
          <option value="N">Não</option>
        </Select>
      </Td>
      <Td textAlign="end">
        <DesativarPeriodo vendedor={vendedor} />
      </Td>
      <Td textAlign="end">
        <DesligarVendedor codigoVendedor={vendedor.codigo_vendedor} nomeVendedor={vendedor.nome_vendedor} />
      </Td>
      <Td textAlign="end">
        <AtivarRotinas codigoVendedor={vendedor.codigo_vendedor} nomeVendedor={vendedor.nome_vendedor} />
      </Td>
      <Td textAlign="center">
        <RetornarPadrao codigoVendedor={vendedor.codigo_vendedor} nomeVendedor={vendedor.nome_vendedor} />
      </Td>
      <Td textAlign="end">{vendedor?.chamados_dia}</Td>
      <Td textAlign="end">{vendedor?.chamados_semanal}</Td>
      <Td textAlign="end">{vendedor?.chamados_mes}</Td>
    </Tr>
  )
}
